import { Component, OnInit } from '@angular/core';
import { PermitDetailsModel, PermitService, PermitDetailsVehicleItemModel } from '../services/permit.service';
import { AuthorizeService, ErrorHandlingService, LocalParserFormatter } from 'core-lib';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { FileListModel, FileListItemModel } from '../components/file-upload/file-upload.component';
import { environment } from '../../environments/environment';

@Component({
  selector: 'cli-vehicles-list',
  templateUrl: './vehicles-list.component.html',
  styleUrls: ['./vehicles-list.component.scss']
})
export class VehiclesListComponent implements OnInit {

  public vm: VehicleListViewModel;
  constructor(private permitSvc: PermitService,
    private errorHandlingSvc: ErrorHandlingService,
    private authorizeService: AuthorizeService,
    private formatter: LocalParserFormatter,
    private router: Router) {
    this.vm = new VehicleListViewModel();
  }

  ngOnInit() {
    this.vm.isLoading = true;
    this.vm.isOpening = !this.permitSvc.model;

    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.mapModel(this.vm, data);
    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);

      }).finally(() => {
        this.vm.isLoading = false;
        this.vm.isOpening = false;
      });
  }

  public downloadCsv() {

    window.open(environment.vehicleDownloadUrl + '?userId=' + this.authorizeService.userId, '_self');
  }

  mapModel(vm: VehicleListViewModel, data: PermitDetailsModel) {
    vm.businessName = data.permitDetails.clientName;
    vm.contactName = data.permitDetails.firstName + ' ' +  data.permitDetails.lastName;
    vm.permitNo = data.permitDetails.permitNo;

    vm.status = data.permitDetails.status;
    vm.expiryDate = this.formatter.toDate(this.formatter.fromIsoString(data.permitDetails.expiryDate));
    vm.isExpired = vm.expiryDate < moment().toDate();

    let daysBeforeExpiry = moment.duration(moment(vm.expiryDate).diff(moment())).asDays();

    // one month before
    vm.isRenewable = daysBeforeExpiry < 31;

    vm.activeVehicles = _(data.vehicles)
      .filter((v: PermitDetailsVehicleItemModel) => { return v.status === 'Active'; })
      .map((v: PermitDetailsVehicleItemModel) => { return this.mapVehicle(v); })
      .value();

    vm.expiredVehicles = _(data.vehicles)
      .filter((v: PermitDetailsVehicleItemModel) => { return v.status === 'Cancelled'; })
      .map((v: PermitDetailsVehicleItemModel) => { return this.mapVehicle(v); })
      .value();
  }

  mapVehicle(v: PermitDetailsVehicleItemModel): VehicleListItemViewModel {
    let vm = new VehicleListItemViewModel();
    vm.regoNo = v.rego;
    vm.state = v.regoState;
    vm.capacity = v.capacity;
    vm.vehicleType = v.vehicleType;
    vm.vehicleMake = v.vehicleMake;
    vm.vehicleId = v.vehicleId;
    vm.isExpired = moment(v.endDate).toDate() < moment().toDate();
    vm.hasDevice = v.hasDevice;
    vm.deviceNo = v.deviceNo;
    vm.isAirGap = v.isAirGap;
    vm.isRPZD = v.isRPZD;
    vm.startDate = this.formatter.toDate(this.formatter.fromIsoString(v.startDate));
    vm.endDate = this.formatter.toDate(this.formatter.fromIsoString(v.endDate));
    vm.certificateIssueDate = this.formatter.toDate(this.formatter.fromIsoString(v.backflowPreventionCertificateIssueDate));
    vm.commissionDate = this.formatter.toDate(this.formatter.fromIsoString(v.commissionDate));
    vm.isRemovalRequested = v.isRemovalRequested;
    vm.status = v.status;


    vm.fileList.items = _.map(v.attachments, (a: any) => {

      let item = new FileListItemModel();

      item.fileId = a.fileId;
      item.fileName = a.fileName;
      item.dateCreated = moment(a.dateCreated).toDate();
      item.fullUrl = environment.downloadFileUrl + '/' + a.fileId;
      item.isRemovable = true;
      return item;
    });


    return vm;
  }

  public renewPermit() {
    this.router.navigate(['/app/renew-permit']);
  }

  public addVehicle() {
    this.router.navigate(['/app/vehicle-add']);
  }

}

export class VehicleListViewModel {
  constructor() {
    this.activeVehicles = [];
    this.expiredVehicles = [];
  }
  public isOpening: boolean;
  public isLoading: boolean;
  public businessName: string;
  public contactName: string;
  public permitNo: string;
  public expiryDate: Date;
  public isExpired: boolean;
  public isRenewable: boolean;
  public status: string;

  public activeVehicles: VehicleListItemViewModel[];
  public expiredVehicles: VehicleListItemViewModel[];
}

export class VehicleListItemViewModel {

  constructor(){
    this.fileList = new FileListModel();
  }

  public vehicleId: string;
  public regoNo: string;
  public capacity: number;
  public vehicleType: string;
  public vehicleMake: string;
  public status: string;
  public state: string;
  public startDate: Date;
  public endDate: Date;
  public isExpired: boolean;
  public hasDevice: boolean;
  public deviceNo: string;
  public isRPZD: boolean;
  public isAirGap: boolean;
  public isRemovalRequested: boolean;
  public certificateIssueDate: Date;
  public commissionDate: Date;
  public warnings: VehicleWarningViewModel[];
  public fileList: FileListModel;
}

export class VehicleWarningViewModel {
  level: string;
  message: string;
}
